import React from 'react';

const ArrowOutwardIcon = function ArrowOutwardIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M4.33329 3.66675V5.00008H10.06L3.66663 11.3934L4.60663 12.3334L11 5.94008V11.6667H12.3333V3.66675H4.33329Z" fill="#979AA0" />
    </svg>
  );
};

export default ArrowOutwardIcon;
